import { useRef, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function fileUrl(id) {
  return `${BACKEND}/api/files/${id}`;
}

export default function ImageUpload({ value, onChange, label = "Image", testid = "image-upload", aspect = "aspect-[4/3]" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const isUploadedId = value && !value.startsWith("http") && !value.startsWith("/");

  const handleFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!/^image\/(jpeg|png|webp|gif)$/.test(f.type)) {
      toast.error("Format non supporté (JPG/PNG/WEBP/GIF)");
      return;
    }
    if (f.size > 8 * 1024 * 1024) { toast.error("Image trop volumineuse (max 8 Mo)"); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.id);
      toast.success("Image envoyée");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const displayUrl = !value ? null : isUploadedId ? fileUrl(value) : value;

  return (
    <div data-testid={testid}>
      <label className="text-[11px] font-mono uppercase tracking-wider text-muted-foreground">{label}</label>
      <div className="mt-1">
        {displayUrl ? (
          <div className={`relative ${aspect} bg-muted card-mc overflow-hidden`}>
            <img src={displayUrl} alt="" className="w-full h-full object-cover" />
            <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange("")} className="absolute top-2 right-2 w-8 h-8 bg-foreground text-background flex items-center justify-center rounded-sm">
              <X className="w-4 h-4" />
            </button>
          </div>
        ) : (
          <button type="button" data-testid={`${testid}-trigger`} onClick={() => inputRef.current?.click()} disabled={uploading}
            className={`${aspect} w-full card-mc flex flex-col items-center justify-center gap-2 text-muted-foreground hover:border-foreground hover:text-foreground transition-colors`}>
            {uploading ? <Loader2 className="w-6 h-6 animate-spin" /> : <Upload className="w-6 h-6" />}
            <span className="text-xs font-mono uppercase tracking-wider">{uploading ? "Envoi…" : "Cliquer pour téléverser"}</span>
            <span className="text-[10px] text-muted-foreground">JPG · PNG · WEBP · max 8 Mo</span>
          </button>
        )}
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={handleFile} data-testid={`${testid}-input`} />
      </div>
    </div>
  );
}
